import Home from "./HomeContainer";

export default Home;
